module.exports = {"230711002":"红旗社区","230711003":"团结社区","230711004":"繁荣社区","230711005":"奋斗社区","230711006":"振华社区","230711007":"先锋社区","230711008":"长征社区","230711009":"锦河社区","230711400":"伊敏林场","230711401":"伊东中心林场","230711402":"东方红农场","230711403":"翠岭经营所","230711404":"乌马河经营所","230711405":"青山林场","230711406":"育苗经营所","230711407":"安全经营所","230711408":"伊青经营所","230711409":"前进经营所","230711410":"西岭林场","230711411":"伊林经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230711.json
// module id = 750
// module chunks = 0